import React from 'react';
import "./TertiaryButton.scss"

const TertiaryButton = (props) => {
    const { onClick, disabled, text, className="" } = props;
    return (
        <button className={className + " tertiary-button"} onClick={onClick} disabled={disabled}>
                {text}
        </button>
    )
}

export default TertiaryButton;